import dayjs from 'dayjs';

import { formatDate } from '@/forms/utils/formatDate';

import { styled } from '@mui/joy';
import Typography from '@mui/joy/Typography';

import CalendarIcon from '@assets/calendar.svg?react';

dayjs.locale('uk');

export const StyledDataChip = styled(Typography)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: `${theme.spacing(0.25)} ${theme.spacing(1)}`,
  background: theme.palette.isDarkMode
    ? theme.palette.neutral[200]
    : theme.palette.neutral[100],
  borderRadius: theme.spacing(1),
  color: theme.palette.neutral[700],
  fontWeight: 600,
  svg: {
    width: '20px',
    height: '20px',
    fill: theme.palette.neutral[500],
  },
}));

export const DateChip = ({
  startDate,
  format,
}: {
  startDate: string;
  format?: string;
}) => (
  <StyledDataChip level='body-sm'>
    <CalendarIcon />
    {formatDate(startDate, format)}
  </StyledDataChip>
);
